module.exports = __webpack_public_path__ + "static/img/pic_jj@2x.ba5bf6f0.png";